import React, { useEffect, useRef, useState } from "react";
import { Card, CardBody, CardTitle, Modal, Table } from "reactstrap";
import { useTranslation } from "react-i18next";
import { ToolTip } from "../../AbstractElements";
import { suggestionService } from "./service/dashboard-service";
import { topSuggestionData } from "./data/data"

const TopSuggestion = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState();
  const [selectedItem, setSelectedItem] = useState(null);

  const [tooltipOpen, setTooltipOpen] = useState({});
  const [testTooltipOpen, setTestTooltipOpen] = useState({});

  const eyeButtonRefs = useRef({});
  const testButtonRefs = useRef({});

  const toggleTooltip = (id) => {
    setTooltipOpen((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const toggleTestTooltip = (id) => {
    setTestTooltipOpen((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setLoading(true);
      const res = await suggestionService();

      if (res?.data?.data?.suggestion) {
        setData(res.data.data.suggestion);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const formatPatientName = (patient) => {
    const { first_name, middle_name, last_name } = patient;
    return `${first_name} ${middle_name || ""} ${last_name}`
      .replace(/\s+/g, " ")
      .trim();
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const formatDateWithMonth = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "long",
      day: "2-digit",
    });
  };

  return (
    <Card>
      <CardBody>
        <CardTitle tag="h5">{t("Top 10 Suggestions")}</CardTitle>
        <div className="recent-table table-responsive currency-table">
          <Table className="mb-0 table-center table-bordered table-hover">
            <thead>
              <tr>
                <th style={{ whiteSpace: "nowrap", width: "15%" }}>
                  {t("Patient Name")}
                </th>
                <th style={{ whiteSpace: "nowrap" }}>{t("Tests")}</th>
                <th style={{ whiteSpace: "nowrap", width: "15%" }}>
                  {t("NAKBHO Health ID")}
                </th>
                <th style={{ whiteSpace: "nowrap", width: "10%" }}>
                  {t("Date")}
                </th>
                <th
                  className="text-center"
                  style={{ whiteSpace: "nowrap", width: "8%" }}
                >
                  {t("Actions")}
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="5" className="mb-2 text-center">
                    Loading...
                  </td>
                </tr>
              ) : data.length > 0 ? (
                data.map((item, idx) => (
                  <tr key={item._id}>
                    <td
                      style={{
                        whiteSpace: "nowrap",
                        width: "15%",
                        paddingLeft: 8,
                      }}
                    >
                      {formatPatientName(item.patient)}
                    </td>
                    {/* <td style={{ whiteSpace: "normal", width: "auto" }}>
                      {item.investigation?.map((inv, invIndex) => (
                        <div key={invIndex} style={{ marginBottom: "8px" }}>
                          {inv.suggestions?.map((suggestion, suggIndex) => (
                            <div key={suggIndex}>
                              <strong>{suggestion.category_name}:</strong>&nbsp;
                              {suggestion.examinations &&
                              suggestion.examinations.length > 0
                                ? suggestion.examinations
                                    .slice(0, 2)
                                    .map(
                                      (exam, examIndex) =>
                                        `${examIndex + 1}) ${exam.name}`
                                    )
                                    .join(", ") +
                                  (suggestion.examinations.length > 3
                                    ? ", ..."
                                    : "")
                                : "No tests"}
                            </div>
                          ))}
                        </div>
                      ))}
                    </td> */}
                    <td style={{ whiteSpace: "normal", width: "auto" }}>
                      <span
                        id={`TestToolTip-${item._id}`}
                        ref={(el) => (testButtonRefs.current[item._id] = el)}
                        style={{ cursor: "pointer" }}
                        onMouseEnter={() =>
                          setTestTooltipOpen((prev) => ({
                            ...prev,
                            [item._id]: true,
                          }))
                        }
                        onMouseLeave={() =>
                          setTestTooltipOpen((prev) => ({
                            ...prev,
                            [item._id]: false,
                          }))
                        }
                      >
                        {item.investigation?.map((inv, invIndex) => (
                          <div key={invIndex} style={{ marginBottom: "8px" }}>
                            {inv.suggestions?.map((suggestion, suggIndex) => (
                              <div key={suggIndex}>
                                <strong>{suggestion.category_name}:</strong>
                                &nbsp;
                                {suggestion.examinations &&
                                suggestion.examinations.length > 0
                                  ? suggestion.examinations
                                      .slice(0, 2)
                                      .map(
                                        (exam, examIndex) =>
                                          `${examIndex + 1}) ${exam.name}`
                                      )
                                      .join(", ") +
                                    (suggestion.examinations.length > 3
                                      ? ", ..."
                                      : "")
                                  : "No tests"}
                              </div>
                            ))}
                          </div>
                        ))}
                      </span>
                      <ToolTip
                        attrToolTip={{
                          placement: "top",
                          isOpen: testTooltipOpen[item._id] || false,
                          target: `TestToolTip-${item._id}`,
                          toggle: () => toggleTestTooltip(item._id),
                        }}
                      >
                        <div style={{ maxWidth: "300px" }}>
                          {item.investigation?.map((inv, invIndex) => (
                            <div key={invIndex} style={{ marginBottom: "8px" }}>
                              {inv.suggestions?.map((suggestion, suggIndex) => (
                                <div key={suggIndex}>
                                  <strong>{suggestion.category_name}:</strong>
                                  <br/>
                                  {suggestion.examinations &&
                                  suggestion.examinations.length > 0
                                    ? suggestion.examinations
                                        .map(
                                          (exam, examIndex) =>
                                            `${examIndex + 1}) ${exam.name}`
                                        )
                                        .join(", ")
                                    : "No tests"}
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      </ToolTip>
                    </td>
                    <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                      {item.patient?.health_id?.match(/.{1,4}/g).join(" ") || "N/A"}
                    </td>
                    <td style={{ whiteSpace: "nowrap", width: "10%" }}>
                      {formatDate(item.createdAt)}
                    </td>
                    <td className="text-center" style={{ width: "5%" }}>
                      <button
                        className="p-0 btn btn-link text-success small"
                        id={`ViewToolTip-${item._id}`}
                        ref={(el) => (eyeButtonRefs.current[item._id] = el)}
                      >
                        <i
                          className="fa fa-eye"
                          onClick={() => {
                            if (eyeButtonRefs.current[item._id]) {
                              eyeButtonRefs.current[item._id].blur();
                            }
                            setTooltipOpen((prev) => ({
                              ...prev,
                              [item._id]: false,
                            }));
                            setSelectedItem(item);
                            setModal(true);
                          }}
                          style={{ fontSize: "14px" }}
                        ></i>
                        <ToolTip
                          attrToolTip={{
                            placement: "top",
                            isOpen: tooltipOpen[item._id] || false,
                            target: `ViewToolTip-${item._id}`,
                            toggle: () => toggleTooltip(item._id),
                          }}
                        >
                          <strong>{t("View")}</strong>
                        </ToolTip>
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="mb-2 text-center">
                    {t("No data found")}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </CardBody>
      <Modal isOpen={modal} toggle={() => setModal(false)} size="lg">
        <div className="modal-header">
          <div className="d-flex justify-content-between w-100 align-items-end">
            <div className="d-flex flex-column">
              <h5 className="mb-1 modal-title">
                Patient Name&nbsp;
                <strong>
                  {selectedItem?.patient
                    ? formatPatientName(selectedItem.patient)
                    : "N/A"}
                </strong>
              </h5>
              <span>
                NAKBHO Health ID:&nbsp;
                <strong>{selectedItem?.patient?.health_id?.match(/.{1,4}/g).join(" ") || "N/A"}</strong>
              </span>
              <span>
                Gender:&nbsp;
                <strong>
                  {selectedItem?.patient?.gender.charAt(0).toUpperCase() +
                    selectedItem?.patient?.gender.slice(1) || "N/A"}
                </strong>
              </span>
            </div>
            <div className="text-end">
              <small className="text-muted">
                {selectedItem?.createdAt
                  ? formatDateWithMonth(selectedItem.createdAt)
                  : "N/A"}
              </small>
            </div>
          </div>
          <button
            type="button"
            className="btn-close"
            onClick={() => setModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <div className="mb-3">
            <h6 className="mb-0">{t("Lab Test")}</h6>
          </div>

          {selectedItem?.investigation?.map((inv, invIndex) => (
            <div key={invIndex} className="mb-3">
              {inv.suggestion_reason && (
                <div className="mb-3">
                  <label className="form-label">
                    {t("Indication (Reason for test)")}
                  </label>
                  <div className="p-2 border rounded">
                    {inv.suggestion_reason}
                  </div>
                </div>
              )}

              {inv.suggestions?.map((suggestion, suggIndex) => (
                <div key={suggIndex} className="mb-3">
                  <div
                    className="p-2 mb-2 text-white rounded"
                    style={{ backgroundColor: "var(--theme-default)" }}
                  >
                    <strong>{suggestion.category_name}</strong>
                  </div>
                  <div className="flex-wrap gap-3 ps-3 d-flex">
                    {suggestion.examinations?.map((exam, examIndex) => (
                      <div
                        key={examIndex}
                        className="form-check d-flex align-items-center"
                        style={{ minWidth: "150px" }}
                      >
                        <input
                          className="form-check-input tw-w-5 tw-h-5"
                          type="checkbox"
                          checked={true}
                          id={`exam-${invIndex}-${suggIndex}-${examIndex}`}
                          style={{
                            backgroundColor: "var(--theme-default)",
                            borderColor: "var(--theme-default)",
                          }}
                        />
                        <label
                          className="mb-0 form-check-label ms-2"
                          htmlFor={`exam-${invIndex}-${suggIndex}-${examIndex}`}
                        >
                          {exam.name}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </Modal>
    </Card>
  );
};

export default TopSuggestion;
